import { ColumnDef } from '@tanstack/react-table';

import { PayrunApprover } from '@xemplo/gp-types';
import { NameCell } from '@xemplo/table';

import { PayScheduleNavigator } from './payschedule-navigator';

export const usePayrunApproverColumnHandler = () => {
  const payrunApproversListColumns: ColumnDef<PayrunApprover>[] = [
    {
      id: 'userId',
      accessorKey: 'userId',
      header: 'User',
      enableSorting: false,
      cell: ({ row }) => {
        const [firstName, lastName] = row.original?.name?.split(' ') ?? ['', ''];
        const profilePhoto = row.original?.profilePhoto;
        return <NameCell {...{ firstName, lastName, profilePhoto }} />;
      },
    },
    {
      id: 'userName',
      accessorKey: 'userName',
      header: 'Email',
      enableSorting: false,
    },
    {
      id: 'payrunTypeId',
      accessorKey: 'payrunTypeId',
      header: 'Payrun Type',
      enableSorting: false,
      cell: ({ row }) =>
        row.original.payrunTypeId === 0 ? 'All' : row.original.payrunTypeName,
    },
    {
      id: 'payschedules',
      accessorKey: 'payschedules',
      header: 'Pay Schedules',
      enableSorting: false,
      cell: ({ row }) => {
        return <PayScheduleNavigator paySchedules={row.original.payschedules} />;
      },
    },
  ];

  return { payrunApproversListColumns };
};
